export default function BlogCTA() {
    return (
      <section className="blog-cta">
        <div className="blog-cta-inner">
          <h3>Create QR Codes That Actually Perform</h3>
          <p>
            Generate high-contrast, printable QR codes. Track scans. Update destinations
            without reprinting.
          </p>
          <a href="/app" className="blog-cta-button">
            Try PrintQR Free
          </a>
        </div>
      </section>
    );
  }  